import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";
import NavigationBar from "./NavigationBar";

const DeferredCustomCursor = lazy(() => import("../components/CustomCursor"));
const DeferredParticlesBackground = lazy(
  () => import("../components/ParticlesBackground"),
);

const PageContentFallback = () => {
  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 112px)",
        display: "grid",
        placeItems: "center",
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );
};

const MainLayout = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        isolation: "isolate",
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: "fixed",
          inset: 0,
          width: "100vw",
          height: "100dvh",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <DeferredParticlesBackground />
      </Box>
      <DeferredCustomCursor />
      <NavigationBar />
      <Box>
        <Suspense fallback={<PageContentFallback />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
};

export default MainLayout;
